@keyframes indeterminate1 {
  0% {
    left: -35%;
    right: 100%;
  }
  60% {
    left: 100%;
    right: -90%;
  }
  100% {
    left: 100%;
    right: -90%;
  }
}

@keyframes indeterminate2 {
  0% {
    left: -200%;
    right: 100%;
  }
  60% {
    left: 107%;
    right: -8%;
  }
  100% {
    left: 107%;
    right: -8%;
  }
}

.root {
  position: relative;
  overflow: hidden;
  display: block;
  height: 4px;
  width: 100%;
  background-color: color-mix(in oklch, var(--tuna-palette-primary-main) 30%, transparent);
  border-radius: var(--tuna-shape-borderRadius);
}

.bar {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: auto;
  background-color: var(--tuna-palette-primary-main);
  transition: transform 0.4s linear;
  transform-origin: left;
}

.indeterminate .bar:first-child {
  animation: indeterminate1 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
}

.indeterminate .bar:last-child {
  animation: indeterminate2 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
}

.colorSecondary {
  background-color: color-mix(in oklch, var(--tuna-palette-secondary-main) 30%, transparent);
}

.colorSecondary .bar {
  background-color: var(--tuna-palette-secondary-main);
}
